// @flow
import { get } from 'lodash';
import type { UiState, LayoutState } from '@types';


export const checkIfIsMobile = (ui: UiState | LayoutState) => window.isCordovaApp && (get(ui, ['window', 'width'], 0) < 1020);

// Whether a field focuses itself when it appears. autofocus is for the web: in the apps focusing opens
// the keyboard over the screen, so only mobileAutofocus (a field the person just asked for) focuses there.
export const shouldAutofocus = (autofocus: ?boolean, mobileAutofocus: ?boolean): boolean => (
  autofocus && !window.isCordovaApp ? true : !!mobileAutofocus
);

export const handlePrecisionVisibility = (value: number, floor: number = 1.0, fractionDigits: number = 2) => (value >= floor ? value.toFixed(0) : value.toFixed(fractionDigits));


